import React from "react"
import { storyblokEditable } from "@storyblok/react"

import { Radiobutton } from "gatsby-theme-gba"

const RadiobuttonEditable = ({ blok, visible }) => (
  <div {...storyblokEditable(blok)} key={blok._uid}>
    <Radiobutton
      name={blok.name}
      label={blok.label}
      radioButtons={blok.radioButtton.inputs}
      required={blok.required}
      visible={visible}
    />
  </div>
)

RadiobuttonEditable.defaultProps = {
  visible: true,
}

export default RadiobuttonEditable
